export const TITLE = "Proposal Assignment";
export const SUBTITLE = "Proposals by lead owner";
export const EMPTY_HEADING = "No proposals assigned yet";
export const EMPTY_BODY =
  "As proposals are assigned to people, the distribution will appear here.";
export const CENTER_LABEL = "PROPOSALS";

export const ASSIGNEE_COLORS = [
  "var(--token-border-primary-600)",
  "var(--token-border-primary-400)",
  "var(--token-border-primary-300)",
];

export const OTHERS_COLOR = "var(--token-border-primary-200)";
export const EMPTY_RING_COLOR = "var(--token-surface-gray-200)";
